import React from 'react';
import classNames from 'classnames';

import { SHARE_PANEL_CONFIGURE_TYPE, useSharePanelStore } from 'src/common/store/share.store';
import { ChevronRightStrongIcon } from 'src/monet/icons';

interface Props {
  type: SHARE_PANEL_CONFIGURE_TYPE;
  title: string;
  subTitle: string;
  className?: string;
  wrapperClassName?: string;
  subtitleClassName?: string;
  hideBorderBottom?: boolean;
  disabled?: boolean;
}

export const SharePanelFormSection = ({
  type,
  title,
  subTitle,
  className,
  wrapperClassName,
  subtitleClassName,
  disabled = false,
}: Props) => {
  const onLinkConfigure = useSharePanelStore((state) => state.pushLinkConfigType);

  const onSectionClick = () => {
    if (!disabled) {
      onLinkConfigure(type);
    }
  };

  return (
    <div
      className={classNames(
        'relative flex flex-col space-y-xs text-bedrock-black py-6 has-hover',
        className,
        disabled ? 'opacity-50 cursor-not-allowed pointer-events-none' : 'cursor-pointer'
      )}
      onClick={onSectionClick}
    >
      <div className={classNames('flex items-center justify-between', wrapperClassName)}>
        <span className='text-bedrock-p-strong'>{title}</span>
        <ChevronRightStrongIcon />
      </div>
      <span className={classNames('text-bedrock-p-small', subtitleClassName)}>{subTitle}</span>
    </div>
  );
};
